import React, { ChangeEvent, FC, useRef, useState } from 'react';
import ButtonWithLoadingState from 'components/ButtonWithLoadingState/ButtonWithLoadingState';
import TextInput from 'components/TextInput';
import FormFooterLink from 'components/Auth/FormFooterLink';
import validateForgotPasswordForm, {
  ForgotPasswordFormData,
  ValidateForgotPasswordFormResult,
} from './validateForgotPasswordForm';
import TriggerEventOnEnterKeyDown from 'utils/TriggerEventOnEnterKeyDown';
import { AppRoutes } from 'routes/RouteService';

import styles from './ForgotPasswordForm.module.scss';

interface ForgotPasswordFormProps {
  onSubmit: (data: ForgotPasswordFormData) => Promise<void>;
}

const ForgotPasswordForm: FC<ForgotPasswordFormProps> = ({ onSubmit }) => {
  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState<ValidateForgotPasswordFormResult>({});

  const handleChangeEmailValue = (e: ChangeEvent<HTMLInputElement>) => {
    setErrors({});

    setEmail(e.target.value);
  };

  const handleSubmit = async () => {
    const validationResult = validateForgotPasswordForm({ email });

    setErrors(validationResult);

    if (Object.keys(validationResult).length === 0) {
      await onSubmit({ email });
    }
  };

  const handleBlur = () => {
    const validationResult = validateForgotPasswordForm({ email });

    setErrors(validationResult);
  };

  const submitIsDisabled = Object.keys(validateForgotPasswordForm({ email })).length > 0;

  return (
    <div className={styles.container}>
      <TextInput
        labelTitle="Email"
        value={email}
        errorMessage={errors.email}
        className={styles.email}
        onChange={handleChangeEmailValue}
        onBlur={handleBlur}
        onKeyDown={TriggerEventOnEnterKeyDown(submitButtonRef, 'click')}
      />
      <ButtonWithLoadingState
        kind="primary"
        size="form"
        onClick={handleSubmit}
        fullWidth
        className={styles.submitButton}
        disabled={submitIsDisabled}
      >
        Reset Password
      </ButtonWithLoadingState>
      <FormFooterLink linkText="Sign in" text="Remember Password?" to={AppRoutes.SignIn} />
    </div>
  );
};

export default ForgotPasswordForm;
